import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9 4.75L6 4.75C5.30964 4.75 4.75 5.30964 4.75 6L4.75 9" vectorEffect="non-scaling-stroke" />
		<Path opacity=".25" d="M15 19.25L18 19.25C18.6904 19.25 19.25 18.6904 19.25 18L19.25 15M9 19.25L6 19.25C5.30964 19.25 4.75 18.6904 4.75 18L4.75 15M19.25 9L19.25 6C19.25 5.30964 18.6904 4.75 18 4.75L15 4.75" vectorEffect="non-scaling-stroke" />
	</SVG>
);
